export default __webpack_public_path__ + "images/c0e70bdb48c273843d28c08b1554ac8d.svg";